<template>
  <div :class="['header', showLogo ? '' : 'header-other']">
    <div class="topbar clear">
      <div class="warp">
        <div
          :class="['head_area', showArea ? 'dropdown' : '']"
          @mouseover="onMouseover"
          @mouseout="onMouseout"
        >
          <div class="topbar-area-main">
            <div class="head_a">
              <i class="iconfont icon__area">&#xe79e;</i><b>{{areaname}}</b
              ><i class="iconfont icon__cur">&#xe79a;</i>
            </div>
          </div>
          <div class="topbar-dropdown head_cont_zx">
            <div class="topbar-dropdown-icon"><i></i><b></b></div>
            <div class="head_list">
              <div class="head_list_hot">
                <div class="head_lsit_title">热门城市</div>
                <ul>
                  <li v-for="item in hotCity" :key="item.id">
                    <a :href="wwwSite + item.url">{{ item.title }}</a>
                  </li>
                </ul>
                <div class="head_list_more">
                  <a :href="wwwSite + 'region'">更多城市></a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="topbar_navlist">
          <ul>
            <li><a :href="wwwSite">首页</a></li>
            <li><a :href="wwwSite + 'ask'">法律咨询</a></li>
            <li><a :href="wwwSite + 'lawyer'">找律师</a></li>
            <li><a :href="wwwSite + 'article'">法律资讯</a></li>
            <li v-if="gid==1"><a :href="wwwSite + '/index/commonweb'">律师常用网站</a></li>
          </ul>
        </div>
        <div class="mobile_tag">
          <a :href="mSite"
            ><i class="iconfont phone__icon">&#xe79d;</i><span>移动端</span></a
          >
        </div>
        <ul class="login_cont">
          <li v-if="userInfo && userInfo.avatar" class="login_box">
            <!-- 已登录 -->
            <div
              :class="['topbar-user', showEnter ? 'dropdown' : '']"
              @mouseover="onMouseoverLogin"
              @mouseout="onMouseoutLogin"
            >
              <div class="topbar-user-main">
                <router-link :to="userIndex">
                  <img :src="userInfo.avatar" /><span>{{ userInfo.name }}</span
                  ><i class="iconfont icon__cur"></i>
                </router-link>
                <!-- <a :href="h5Site + 'personal/#/index'"
                  ><img :src="userInfo.avatar" /><span>{{ userInfo.name }}</span
                  ><i class="iconfont icon__cur"></i></a
                > -->
              </div>
              <div class="topbar-dropdown">
                <div class="topbar-dropdown-icon"><i></i><b></b></div>
                <ul class="topbar-user-list">
                  <li v-for="item in menuList" :key="item.id">
                    <router-link :to="gid == 2 ? '/auth/info' : item.url">{{ item.title }}</router-link>
                  </li>
                </ul>
              </div>
            </div>
            <em class="line__cur"></em
            ><a
              href="javascript:void(0)"
              @click="loginout"
              class="red forLoginout"
              >退出</a
            >
          </li>
        </ul>
      </div>
    </div>
    <div v-if="showLogo" class="warp header__bottom clear">
      <a class="head_logo" :href="wwwSite"></a>
    </div>
  </div>
</template>

<script>
import { site } from "../utils/site";
import { loginout } from "../webapi/api";
export default {
  name: "tsheader",
  props: {
    showLogo: {
      type: Boolean,
      default: true,
    },

    userInfo: {
      type: Object,
    },

    gid: {
      type: String,
    },

    areaname: {
      type: String
    }
  },
  data() {
    return {
      userIndex: "",
      showArea: false,
      showEnter: false,
      wwwSite: site.www.url(),
      mSite: site.m.url(),
      h5Site: site.h5site.url(),
      ucSite: site.uc.url(),
      hotCity: [
        {
          id: 1,
          title: "北京",
          url: "beijing",
        },
        {
          id: 2,
          title: "上海",
          url: "shanghai",
        },
        {
          id: 3,
          title: "广州",
          url: "guangzhou",
        },
        {
          id: 4,
          title: "深圳",
          url: "shenzhen",
        },
        {
          id: 5,
          title: "成都",
          url: "chengdu",
        },
        {
          id: 6,
          title: "杭州",
          url: "hangzhou",
        },
        {
          id: 7,
          title: "南京",
          url: "nanjing",
        },
        {
          id: 8,
          title: "天津",
          url: "tianjin",
        },
        {
          id: 9,
          title: "武汉",
          url: "wuhan",
        },
      ],

      consumerList: [
        {
          id: 1,
          title: "个人中心",
          url: "/consumer",
        },
        {
          id: 2,
          title: "我的咨询",
          url: "/consult/free",
        },
      ],

      lawyerList: [
        {
          id: 1,
          title: "个人中心",
          url: "/index",
        },
        {
          id: 2,
          title: "咨询管理",
          url: "/ask/common",
        },
        {
          id: 3,
          title: "资金管理",
          url: "/money/capital",
        },
        {
          id: 4,
          title: "律师认证",
          url: "/auth/info",
        },
        {
          id: 5,
          title: "设置",
          url: "/set/askset",
        },
      ],

      menuList: [],
    };
  },
  created() {
    this.menuList = this.gid == 1 || this.gid == 2 ? this.lawyerList : this.consumerList;
    this.userIndex = this.gid == 1 || this.gid == 2 ? '/index' : '/consumer';
  },
  methods: {
    //退出登录
    loginout() {
      this.$fetch
        .fetchData({
          url: loginout,
          data: { _ajax: 1 },
        })
        .then(() => {
          window.location.href = this.ucSite + "pub/wlogin";
        })
        .catch((e) => {
          this.toast(e.errMsg || "请求错误");
        });
    },

    onMouseover(e) {
      this.showArea = true;
    },

    onMouseout(e) {
      this.showArea = false;
    },

    onMouseoverLogin(e) {
      this.showEnter = true;
    },

    onMouseoutLogin(e) {
      this.showEnter = false;
    },

    //消息提示
    toast(msg) {
      this.$message({
        type: "error",
        showClose: true,
        message: msg,
        offset: 50,
      });
    },
  },
};
</script>

<style scoped>
.header {
  margin-bottom: 20px;
  background: #fff;
}
/* topbar start */
.topbar {
  line-height: 40px;
  color: #999;
  position: relative;
  z-index: 999;
}
.warp {
  width: 1200px;
  margin: 0 auto;
}
.topbar ul.login_cont {
  float: right;
}
.topbar ul.login_cont li {
  float: left;
}
.topbar a:hover {
  color: #999;
}
.topbar a.red {
  font-size: 12px;
  color: #999;
}
.topbar a.red:hover {
  color: #1476f9;
}
.topbar i {
  vertical-align: top;
}
.topbar-login a {
  color: #999;
  font-size: 12px;
}
.topbar .line__cur {
  display: inline-block;
  width: 1px;
  height: 14px;
  background-color: #ddd;
  vertical-align: -2px;
  margin: 0 8px;
}

.topbar-user {
  float: left;
  position: relative;
}

.topbar-user-main img {
  width: 24px;
  height: 24px;
  border-radius: 100%;
  float: left;
  margin: 8px 8px 0 0;
}
.topbar-user-main span {
  display: inline-block;
  margin-right: 6px;
  color: #999;
  font-size: 12px;
}

.topbar-user-list {
  width: 130px;
  padding: 8px 0;
}
.topbar-user-list li {
  width: 100%;
  text-align: center;
}
.topbar-user-list a {
  display: block;
  line-height: 30px;
  color: #333;
  font-size: 14px;
}
.topbar-user-list a:hover {
  color: #1476f9;
}
.topbar-dropdown {
  position: absolute;
  background-color: #fff;
  border: 1px solid #d5d5d5;
  border-radius: 5px;
  left: 50%;
  margin-left: -66px;
  top: 40px;
  display: none;
}
.topbar-dropdown-icon i,
.topbar-dropdown-icon b {
  width: 0;
  height: 0;
  line-height: 0;
  border-width: 6px;
  border-style: dashed dashed solid dashed;
  position: absolute;
  left: 50%;
  margin-left: -7px;
}
.head_cont_zx .topbar-dropdown-icon i,
.head_cont_zx .topbar-dropdown-icon b {
  margin-left: -70px;
}
.topbar-dropdown-icon i {
  border-color: transparent transparent #d5d5d5 transparent;
  top: -12px;
}
.topbar-dropdown-icon b {
  border-color: transparent transparent #fff transparent;
  top: -11px;
}
.topbar-mail-main span {
  width: 14px;
  height: 14px;
  line-height: 14px;
  font-size: 12px;
  text-align: center;
  overflow: hidden;
  border-radius: 100%;
  background-color: #f32e3d;
  color: #fff;
  display: block;
  position: absolute;
  top: 10px;
  right: -4px;
}
.topbar-mail-main i {
  background: url(//cdn.tingsonglaw.com/img/tip_dope.png) 0 2px no-repeat;
  width: 22px;
  height: 20px;
  display: inline-block;
  vertical-align: middle;
}

.head_cont_zx {
  width: 235px;
  padding: 10px;
}
.head_area {
  float: left;
  position: relative;
  height: 40px;
}
.head_area a:hover {
  color: #333;
}
.head_area .head_a {
  overflow: hidden;
  display: block;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
}
.head_area .head_a b {
  font-weight: normal;
  display: inline-block;
  font-size: 12px;
  color: #999;
  padding: 0 6px;
  line-height: 40px;
  min-width: 10px;
  height: 40px;
  max-width: 150px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.topbar .icon__area {
  color: #1476f9;
  font-size: 14px;
}
.topbar .icon__cur {
  display: inline-block;
  color: #999;
  font-size: 12px;
  transition: all 0.2s ease;
}
.topbar_navlist {
  float: left;
  padding-left: 20px;
}
.topbar_navlist ul li {
  float: left;
}
.topbar_navlist ul li a {
  color: #999;
  padding: 0 10px;
  font-size: 12px;
}

.mobile_tag {
  float: right;
  padding: 0 0 0 20px;
}

.mobile_tag a {
  color: #999;
}

.mobile_tag span {
  margin-left: 4px;
  font-size: 12px;
}

.mobile_tag .phone__icon {
  font-size: 14px;
}
.head_lsit_title {
  font-size: 14px;
  font-weight: bold;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
  margin: 0 25px 10px 25px;
  line-height: 24px;
  color: #333;
}
.head_list_hot {
  width: 235px;
  padding-top: 10px;
}
.head_list_hot ul {
  overflow: hidden;
}
.head_list_hot ul li {
  float: left;
  padding: 3px 25px;
  line-height: 28px;
}
.head_list_hot ul li a {
  color: #666;
  font-size: 14px;
}
.head_list_hot ul li a:hover {
  color: #1476f9;
}
.head_list_more a {
  text-align: right;
  display: block;
  color: #1476f9;
  font-size: 14px;
  padding-right: 25px;
  padding-top: 4px;
}
.head_list_more a:hover {
  color: #1476f9;
}

.topbar_navlist ul li a:hover,
.topbar-login a:hover,
.mobile_tag a:hover {
  color: #1476f9;
}

.dropdown .topbar-dropdown {
  display: block;
}

.dropdown .icon__cur {
  color: #1476f9;
  transform: rotate(180deg);
}

.dropdown .topbar-user-main span,
.dropdown .head_a b {
  color: #1476f9;
}
/* topbar end */

/*logo*/
.header__bottom {
  height: 80px;
}
.head_logo { 
  margin-top: 18px;
  float:left; 
  background: url(https://c3-cdn.tingsonglaw.com/up/all/20210927/456c6e5ffa7971034e0d581348a0430d.png) no-repeat;
  width: 110px;
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue